import { Home } from "../layout";
import PageLayout from "./PageLayout";

const HomePage = () => {
  return (
    <PageLayout>
      <Home />
    </PageLayout>
  );
};

export default HomePage;
